module.exports = __webpack_public_path__ + "static/media/ic_rectangle_selected.db86d8ef.svg";